import { createFileRoute } from '@tanstack/react-router'

import { BulkSettlePage } from '@/components/pages/Admin/Outstanding/BulkSettle/BulkSettlePage'

export const Route = createFileRoute('/(dashboard)/admin/outstanding/settle')({
  component: OutstandingSettleRoute,
})

function OutstandingSettleRoute() {
  return <BulkSettlePage />
}
